<div class="dashboard-container">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" >
    <mat-tab label="View Boards">
      <ng-container *ngIf="selectedTabIndex === 0">
        <bhub-view-boards
          [boards]="boards"
        ></bhub-view-boards>
      </ng-container>
    </mat-tab>

    <mat-tab label="Manage Boards">
      <ng-container *ngIf="selectedTabIndex === 1">
        <bhub-manage-boards
        [boards]="boards"
        ></bhub-manage-boards>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</div>
